import {useApi} from "@contexts/hooks/api/useApi.ts";
import {ICreateContratoDto} from "@components/contratos/models/ICreateContratoDto.ts";
import {__contrato_endpoints} from "@components/contratos/endpoints/__contrato_endpoints.ts";
import {IDataDto} from "@models/shared/IDataDto.ts";
import {useValue} from "@components/shared/hooks/useValue.tsx";
import {IContrato} from "@models/contratos/contrato.ts";
import {IContratoParcela} from "@models/contratos/parcelamento.ts";
import {ICreateContratoParcelaDto} from "@components/contratos/models/ICreateContratoParcelaDto.ts";

export const useContrato = () => {
    const {Get} = useApi()

    const createContrato = (data: ICreateContratoDto) => {
        return Get(__contrato_endpoints.v2['create-contrato']({data: data}))
    }
    const getParcelas = (data: IDataDto<{ idContrato: number }>) => {
        return Get(__contrato_endpoints.v2['get-parcelas'](data))
    }

    const getContratoById = (data: { idContrato: number }) => {
        return Get(__contrato_endpoints.v2["get-contrato-by-id"]({data}))
    }

    const getParcelaById = (data: { idParcela: number }) => {
        return Get(__contrato_endpoints.v2["get-parcela-by-id"]({data}))
    }

    const getContratoDetalhesById = (data: { idContrato: number }) => {
        return Get(__contrato_endpoints.v2["get-contrato-detalhes-by-id"]({data}))
    }
    const createParcela = (data: ICreateContratoParcelaDto) => {
        return Get(__contrato_endpoints.v2['create-parcela']({data: data}))
    }

    const updateAllParcelas = (data: {
        idContrato: number,
        remover: number[],
        atualizar: Partial<Omit<ICreateContratoParcelaDto, 'idContrato'>> & { parcelaId: number }[],
    }) => {
        return Get(__contrato_endpoints.v2['update-all-parcelas']({data: data}))
    }
    const undraftContrato = (data: { idContrato: number }) => {
        return Get(__contrato_endpoints.v2['undraft-contrato']({data: data}))
    }
    const updateContrato = (data: {
        idContrato: number,
        isUsaDiferimento?: boolean,
        isTerminoIndefinido?: boolean,
    } & Partial<ICreateContratoDto>) => {
        return Get(__contrato_endpoints.v2['update-contrato']({data: data}))
    }

    return {
        getParcelas: getParcelas,
        getParcelaById: getParcelaById,
        getContratoById: getContratoById,
        getContratoDetalhesById: getContratoDetalhesById,
        createContrato: createContrato,
        updateAllParcelas: updateAllParcelas,
        updateContrato: updateContrato,
        createParcela: createParcela,
        undraftContrato: undraftContrato,
        useContratoValue: (c: number | IContrato) => useValue({
            value: c,
            getter: () => getContratoById({idContrato: typeof c === 'number' ? c : c.id})
        }),
        useParcelaValue: (c: number | IContratoParcela) => useValue({
            value: c,
            getter: () => getParcelaById({idParcela: typeof c === 'number' ? c : c.id})
        }),
    };
};